module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_08-ce4b818feadb96b01536c6d7bb8b1cca.svg";